import { animated, useSpring } from '@react-spring/web';
import { useTranslation } from 'react-i18next';

import { Paragraph } from '@app/shared/ui/atoms/Common';
import { SlideContainer, SlideHeading } from '@app/shared/ui/atoms/DailyEnergy';
import {
  SYMBOL_IMAGE_SPRING_CONFIGS_MAP,
  DESCRIPTION_SPRING_CONFIGS_MAP,
} from '@app/shared/constants/dailyEnergy';

interface SlideTwoContentProps {
  symbolIconScr: string;
  day: number;
  dayDescription: string;
}

export function SlideTwoContent({ symbolIconScr, day, dayDescription }: SlideTwoContentProps) {
  const { t } = useTranslation();

  const symbolImageSprings = useSpring({
    ...SYMBOL_IMAGE_SPRING_CONFIGS_MAP[1],
    reverse: true,
  });
  const descriptionSprings = useSpring({ ...DESCRIPTION_SPRING_CONFIGS_MAP[2] });

  return (
    <SlideContainer>
      <animated.img
        style={symbolImageSprings}
        src={symbolIconScr}
        alt="symbol"
        className="mx-auto mt-[200px] w-[120px]"
      />

      <animated.div style={descriptionSprings} className="flex flex-col gap-4">
        <SlideHeading>{`${day} ${t('daily_energy.lunar_day')}`}</SlideHeading>

        <Paragraph variant="white" className="whitespace-pre-line font-normal">
          {dayDescription}
        </Paragraph>
      </animated.div>
    </SlideContainer>
  );
}
